import React from 'react';

import BoraPage from '../components/BoraPage';
import BoraBlaast from '../components/BoraBlaast';

export default () => (
  <BoraPage pageName="Blog" pageTitle="Geniet van onze verhalen" slug="blog">
    <BoraBlaast/>
  </BoraPage>
);
